/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const purchaseOrderPrintSettings = sqliteTable('purchase_order_print_settings', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  clinic_id: text('clinic_id'),
  logo_source: text('logo_source'),
  buyer_name: text('buyer_name'),
  buyer_address: text('buyer_address'),
  buyer_phone: text('buyer_phone'),
  buyer_email: text('buyer_email'),
  buyer_tax_id: text('buyer_tax_id'),
  footer_text: text('footer_text'),
  terms_text: text('terms_text'),
  prepared_by_label: text('prepared_by_label'),
  approved_by_label: text('approved_by_label'),
  supplier_acknowledgment_label: text('supplier_acknowledgment_label'),
  show_sku: integer('show_sku'),
  show_bonus: integer('show_bonus'),
  show_remarks: integer('show_remarks'),
  show_supplier_contact: integer('show_supplier_contact'),
  show_signature_block: integer('show_signature_block'),
  show_terms: integer('show_terms'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
